import { ComponentType } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import ProductList from './ProductList';
import ProductsProvider, {
  ProductsProviderInputProps,
} from '../ProductsProvider';

export default compose(
  ProductsProvider,
  withRouter
)(ProductList) as ComponentType<
  Pick<ProductsProviderInputProps, 'language' | 'searchState'> & {
    condition: ProductsProviderInputProps['condition'] | null;
  }
>;
